import { ButtonProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import {
  addParamsToUrl,
  onboardingQuizPath,
  pathFromLocation,
} from "@outschool/routes";
import { useAnalytics } from "@outschool/ui-analytics";
import {
  AuthTrigger,
  AuthTriggerActionTypes,
  useLoginFlowContext,
  useSession,
} from "@outschool/ui-auth";
import { HeartButton } from "@outschool/ui-components-shared";
import { followUserMutation } from "@outschool/ui-components-website";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";
import { useLocation } from "react-router";

import {
  useFollowUserMutation,
  useUnfollowUserMutation,
} from "../../queries/FollowedUserMutations";

export function FollowButton({
  leader,
  isSet = false,
  onChange = _followed => {},
  size,
}: {
  leader: any;
  isSet?: boolean;
  onChange?: (followed: boolean) => void;
  sx?: SystemStyleObject;
  color?: string;
  size?: ButtonProps["size"];
}) {
  const { enterLoginFlow } = useLoginFlowContext();
  const { t } = useTranslation("client\\components\\saving\\FollowButton");
  const { isLoggedIn } = useSession();
  const followUser = useFollowUserMutation();
  const unfollowUser = useUnfollowUserMutation();
  const location = useLocation();
  const analytics = useAnalytics();

  const handleFollowClick = async (followed: boolean) => {
    const referer = pathFromLocation(location);
    const attribution = await analytics.attribution();
    if (!isLoggedIn) {
      enterLoginFlow({
        authTrigger: AuthTrigger.FOLLOW_TEACHER,
        postLoginAction: {
          actionType: AuthTriggerActionTypes.FOLLOW_AFTER_LOGIN,
          welcomeModalData: { leaderName: leader.name },
          graphqlMutation: {
            mutation: followUserMutation,
            variables: {
              userUid: leader.uid,
              referer,
              attribution,
            },
          },
          shouldPopUpWelcomeModal: false,
        },
        newUrlAfterSignUp: addParamsToUrl(onboardingQuizPath(), {
          followTeacher: true,
        }),
        newUrlAfterLogin: pathFromLocation(location),
        shouldNavigateOverwrite: false,
      });
    } else {
      if (followed) {
        followUser(leader, referer, attribution);
      } else {
        unfollowUser(leader.uid);
      }
      onChange(followed);
    }
  };

  return (
    <HeartButton
      size={size}
      isSet={isSet}
      setLabel={t`Following`}
      unsetLabel={t`Follow`}
      onChange={handleFollowClick}
    />
  );
}
